/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CurrencyCode {
    UnknownCurrencyCode = 'UNKNOWN_CURRENCY_CODE',
    Aud = 'AUD',
    Cad = 'CAD',
    Eur = 'EUR',
    Gbp = 'GBP',
    Hkd = 'HKD',
    Jpy = 'JPY',
    Nzd = 'NZD',
    Sgd = 'SGD',
    Usd = 'USD'
}

export function CurrencyCodeFromJSON(json: any): CurrencyCode {
    return CurrencyCodeFromJSONTyped(json, false);
}

export function CurrencyCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrencyCode {
    return json as CurrencyCode;
}

export function CurrencyCodeToJSON(value?: CurrencyCode | null): any {
    return value as any;
}

